<template>
    <v-container id="settings" class="fill-height" style="display: block;" fluid>

        <v-tabs v-model="tab" color="#ffffff">
            <v-tabs-slider color="#ffffff"></v-tabs-slider>
            <v-tab key="alarms">Alarms</v-tab>
            <v-tab key="issues">Issues</v-tab>
            <v-tab key="preferences">Preferences</v-tab>
            <v-tab key="sounds">Sounds</v-tab>
            <v-tab key="propagation" :disabled="!propagationPermissions">Propagation</v-tab>
            <v-tab key="reports">Reports</v-tab>
            <v-tab key="system">System</v-tab>
        </v-tabs>


        <v-tabs-items v-model="tab" class="tab-content-full-height">

            <v-tab-item key="alarms">
                <alarms :alarmSettings="settings.alarms"></alarms>
            </v-tab-item>

            <v-tab-item key="issues">
                <issues :issuesSettings="settings.issues"></issues>
            </v-tab-item>

            <v-tab-item key="preferences" eager>
                <v-form ref="preferencesForm" :lazy-validation="true" v-model="preferencesFormValid">
                    <preferences :preferences="settings.preferences"></preferences>
                </v-form>
            </v-tab-item>

            <v-tab-item key="sounds">
                <sounds :soundSettings="settings.sounds"></sounds>
            </v-tab-item>

            <v-tab-item key="propagation">
                <propagation></propagation>
            </v-tab-item>

            <v-tab-item key="reports">
                <reports :reportSettings="settings.reports"></reports>
            </v-tab-item>

            <v-tab-item key="system">
                <system />
            </v-tab-item>

        </v-tabs-items>

        <v-btn class="mt-3" color="#c42111" @click="saveWebAppSettings">Save Settings</v-btn>

    </v-container>
</template>

<script>
import Alarms from "@/components/Settings/Alarms";
import Issues from "@/components/Settings/Issues";
import Sounds from "@/components/Settings/Sounds";
import Preferences from "@/components/Settings/Preferences";
import Propagation from "@/components/Settings/Propagation";
import Reports from "@/components/Settings/Reports";
import System from "@/components/Settings/System";
export default {
    name: 'Settings',
    props: [],
    components: {
        Alarms,
        Issues,
        Sounds,
        Preferences,
        Propagation,
        Reports,
        System
    },
    data: () => ({
        preferencesFormValid: true,
        tab: 0,
        settings: null,
        settingsInitialized: false
    }),

    computed: {
        propagationPermissions: function() {
            return TELSA.checkPermission(this.$store.state.user, 'admin/settings/propagation');
        }
    },

    methods: {
        initializeSettingsClone: function() {
            this.settings = JSON.parse(JSON.stringify(this.$store.state.batchConfig.webapp_settings));
        },

        saveWebAppSettings: function() {
            if(this.$refs.preferencesForm.validate()) {
                TELSA.loading(true);
                let route = (TELSA.apiHost + "settings/save");
                let settingsStr = JSON.stringify(this.settings);
                this.$http.post(route, {args: {webapp_settings: settingsStr}}).then(response => {
                    let result = response.body;
                    this.$store.commit('setWebappSettings', this.settings);
                    this.$store.commit('setIsDirty', false);
                    TELSA.loading(false);
                });
            }
        }
    },

    watch: {
        settings: {
            handler(newVal, oldVal) {
                if(this.settingsInitialized) {
                    this.$store.commit('setIsDirty', true);
                }
                else {
                    this.settingsInitialized = true;
                }
            },
            deep: true
        }
    },

    mounted() {

    },

    created() {
        this.initializeSettingsClone();
    }


};
</script>

<style scoped>

    .v-tabs {
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
    }

    .tab-content-full-height {
        height: calc(100% - 88px);
        /* height: calc(100vh - 192px); */
        position: relative;
        border: #575757 solid 1px;
        border-top: none;
        background-color: #303030;;
        box-shadow: 3px 3px 8px 0px rgba(0,0,0,0.5);
    }

</style>

<style>

    #settings .v-tabs-bar {
        /* box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.5); */
        z-index: 1;
        border: #575757 solid 1px;
        /* border-bottom: #575757 solid 1px; */
    }

    .setting-scope-icon {
        position: absolute !important;
        right: 25px;
    }

    .v-card:not(.v-sheet--tile):not(.v-card--shaped) {
        border-color: rgba(255, 255, 255, 0.12);
    }

</style>
